<script lang="ts">
    import { _ } from "svelte-i18n"
    import NumberField from "../../widgets/fields/NumberField.svelte"

    export let cart: Cart

    let total: number = 0
    let positionsCount: number = 0

    const calculateTotal = () => {
        total = 0
        cart.operations.forEach((operation: Operation, i) => {
            operation.positions.forEach((position: OperationPosition) => {
                if (position.orderQuantity != 0) {
                    total += position.netPrice * position.quantity
                }
            })
        })

        // Advanced shipping notice costs
        if (cart.advanceShippingNotice) {
            total += cart.advanceShippingNotice.costs
        }
    }

    const calculatePositionsCount = () => {
        positionsCount = 0
        cart.operations.forEach((operation: Operation) => {
            operation.positions.forEach((position: OperationPosition) => {
                if (position.orderQuantity != 0) {
                    positionsCount += 1
                }
            })
        })
    }

    $: if (cart) {
        calculateTotal()
        calculatePositionsCount()
    }
</script>

{#if cart}
    <div class="cart-operations-summary layout justify-content-end">
        <div class="layout layout-vertical layout-stretch">
            <div class="layout justify-content-end align-items-center layout-gap-sm">
                <div class="label">{$_("cart.total").toUpperCase()}</div>
                <div class="summary-double-line"></div>
            </div>

            <div class="layout justify-content-end layout-gap-lg tablerow">
                <div class="layout layout-vertical align-items-start">
                    <div class="label">{$_("cart.totalSum").toUpperCase()}</div>
                    <div class="large">
                        <NumberField value="{total}" decimals="{2}" /> €
                    </div>
                </div>
                <div class="layout layout-vertical align-items-center" style="width: 150px;">
                    <div class="label">{$_("cart.amountPos").toUpperCase()}</div>
                    <div class="large">{positionsCount}</div>
                </div>
            </div>
        </div>
    </div>
{/if}
